import type { Persona } from "./persona"

export const ATTRIBUTES_VIEW_COOKIE_NAME = "attributeView"

export const ATTRIBUTES_VIEW = {
  grid: "grid",
  table: "table",
} as const

export type AttributesView = keyof typeof ATTRIBUTES_VIEW

export const getDefaultAttributesView = (persona: Persona) => {
  return persona === "collector" ? ATTRIBUTES_VIEW.grid : ATTRIBUTES_VIEW.table
}

export function parseAttributesView(
  attributesView: string | undefined,
  persona: Persona,
): AttributesView {
  if (attributesView && attributesView in ATTRIBUTES_VIEW) {
    return attributesView as AttributesView
  }

  return getDefaultAttributesView(persona)
}

const attributesViews = Object.values(ATTRIBUTES_VIEW)

export function getAttributesViewStaticParams() {
  return attributesViews.map(attributesView => ({
    attributesView,
  }))
}
